import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';

@Component({
    templateUrl: './client-portal-client-prescriber-task-reports.component.html',
    imports: [ReportsComponent]
})
export class ClientPortalClientPrescriberTaskReportsComponent {
  reportsUrl = `${environment.captureApi.url}/client_prescriber_task_reports`;

  constructor() {}
}
